module.exports = __webpack_public_path__ + "img/p2.644aace7.png";